import React, { useState } from 'react';

interface TokenInfo {
    token: string;
    comment: string;
}

const TokenGenerator: React.FC = () => {
    const [clientName, setClientName] = useState<string>('');
    const [clientSecret, setClientSecret] = useState<string>('');
    const [appToken, setAppToken] = useState<string>('');
    const [existingTokens, setExistingTokens] = useState<TokenInfo[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const handleClientNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setClientName(event.target.value);
    };

    const handleClientSecretChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setClientSecret(event.target.value);
    };

    const generateToken = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.yourservice.com/generate_token', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ clientName, clientSecret })
            });

            if (response.ok) {
                const data = await response.json();
                setAppToken(data.token);
                setExistingTokens([...existingTokens, { token: data.token, comment: 'Newly generated token' }]);
            } else {
                throw new Error('Failed to generate token');
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.inputGroup}>
                <label style={styles.label}>
                    Client Name:
                    <input
                        type="text"
                        value={clientName}
                        onChange={handleClientNameChange}
                        placeholder="Enter client name"
                        style={styles.input}
                    />
                </label>
            </div>
            <div style={styles.inputGroup}>
                <label style={styles.label}>
                    Client Secret:
                    <input
                        type="password"
                        value={clientSecret}
                        onChange={handleClientSecretChange}
                        placeholder="Enter client secret"
                        style={styles.input}
                    />
                </label>
            </div>
            <button onClick={generateToken} style={styles.button} disabled={loading}>
                {loading ? 'Generating...' : 'Generate Token'}
            </button>
            {appToken && (
                <div style={styles.tokenDisplay}>
                    <p>Generated Token: {appToken}</p>
                </div>
            )}
            {existingTokens.length > 0 ? (
                <>
                    <h3 style={styles.heading}>Existing Tokens:</h3>
                    <ul style={styles.tokenList}>
                        {existingTokens.map((item, index) => (
                            <li key={index} style={styles.tokenItem}>
                                Token: {item.token} - Comment: {item.comment}
                            </li>
                        ))}
                    </ul>
                </>
            ) : (
                <br/>
                // <p style={styles.noTokens}>No tokens generated yet.</p>
            )}
        </div>
    );
};

const styles = {
    container: {
        maxWidth: '600px',
        margin: '20px auto',
        padding: '20px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        borderRadius: '8px',
    },
    inputGroup: {
        marginBottom: '15px',
    },
    label: {
        display: 'block',
        marginBottom: '5px',
        fontWeight: 'bold',
        color: '#333',
    },
    input: {
        width: '100%',
        padding: '8px',
        marginBottom: '10px',
        borderRadius: '4px',
        border: '1px solid #ccc',
    },
    button: {
        backgroundColor: '#007BFF',
        color: '#fff',
        padding: '10px 15px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: 'bold',
    },
    tokenDisplay: {
        marginTop: '10px',
        padding: '10px',
        backgroundColor: '#e3f2fd',
        borderRadius: '4px',
    },
    heading: {
        marginTop: '20px',
        fontWeight: 'bold',
        color: '#333',
    },
    tokenList: {
        listStyleType: 'none',
        padding: '0',
    },
    tokenItem: {
        backgroundColor: '#f8f9fa',
        padding: '10px',
        borderRadius: '4px',
        marginTop: '10px',
    }, noTokens: {
        marginTop: '20px',
        textAlign: 'center',
        color: '#888',
    }
};

export default TokenGenerator;
